import { RouteConfig } from 'vue-router'
import Login from '../views/Login.vue'

export type ExtendedRoute = RouteConfig & {
  text?: string,
  key?: string,
  display?: boolean | (() => boolean),
}

export default [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    display: false,
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('../views/Info.vue'),
    text: 'Information de Build',
    display: false,
  },
  {
    path: '/vente/inscription',
    name: 'Inscription',
    component: () => import('../views/registration/Registration.vue'),
    key: 'title.registrations',
    display: false,
  },
  {
    path: '/mes-inscriptions',
    name: 'Inscriptions',
    component: () => import('../views/registration/RegistrationRoot.vue'),
    key: 'title.registrations',
    display: true,
    redirect: { name: 'Prochaines inscriptions' },
    children: [
      {
        path: 'nouveau',
        name: 'Prochaines inscriptions',
        component: () => import('../views/registration/Registrations.vue'),
        key: 'title.new-registrations',
      },
      {
        path: 'recapitulatif',
        name: 'Recapitulatif',
        component: () => import('../views/registration/RegistrationSummary.vue'),
        key: 'title.recap',
      },
      {
        path: 'historique',
        name: 'Historique des inscriptions',
        component: () => import('../views/registration/Registrations.vue'),
        key: 'title.old-registrations',
        props: { old: true },
      },
      {
        path: 'consignment',
        name: 'Consignment',
        component: () => import('../views/registration/RegistrationConsignment.vue'),
        key: 'title.consignment',
      },
    ],
  },
  {
    path: '/mes-inscriptions/:registrationId/documents',
    name: 'DocumentsRegistration',
    component: () => import('../views/registration/documents/DocumentsRegistration.vue'),
    key: 'title.document.registrations',
    props: (route) => ({ registrationId: parseInt(route.params.registrationId, 10) }),
    display: false,
  },
  {
    path: '/mes-inscriptions/:registrationId/pedigree',
    name: 'PedigreeRegistration',
    component: () => import('../views/registration/pedigree/PedigreeRegistration.vue'),
    key: 'title.document.registrations',
    props: (route) => ({ registrationId: parseInt(route.params.registrationId, 10) }),
    display: false,
  },
  {
    path: '/mes-inscriptions/:registrationId/resources',
    name: 'ResourcesRegistration',
    component: () => import('../views/registration/resources/ResourceRegistration.vue'),
    key: 'title.document.registrations',
    props: (route) => ({ registrationId: parseInt(route.params.registrationId, 10) }),
    display: false,
  },
  {
    path: '/mes-informations',
    name: 'Mes informations',
    component: () => import('../views/MesInformations.vue'),
    key: 'title.my-information',
    display: true,
    redirect: { name: 'Mes lieux de visite' },
    children: [
      {
        path: 'lieux-de-visite',
        name: 'Mes lieux de visite',
        component: () => import('../views/place-to-visit/PlacesToVisit.vue'),
        key: 'title.places-to-visit',
      },
      {
        path: 'proprietaires',
        name: 'Propriétaires',
        component: () => import('../views/lot-seller/LotSellers.vue'),
        key: 'title.lot-sellers',
      },
      {
        path: 'entetes',
        name: 'Mes consigners',
        component: () => import('../views/header/Headers.vue'),
        key: 'title.headers',
      },
    ],
  },
  {
    path: '/cgu',
    name: 'Conditions générales de vente',
    component: () => import('../views/CGU.vue'),
    key: 'title.registrations',
    display: false,
  },

  {
    path: '/signing-complete',
    name: 'Signature Terminée',
    component: () => import('../views/signing/SigningComplete.vue'),
    display: false,
  },
] as Array<ExtendedRoute>
